import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { BONUS_TOTAL, OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-b border-arena bg-arena/40" data-id="element-52" data-mp="c7adc3u6m4g0">
      <div className="mx-auto max-w-xl px-4 py-6 text-center sm:py-9" data-id="element-53" data-mp="8573fjn5v7wu">
        <h2 id="cierre" className="font-serif text-3xl text-terracota sm:text-4xl" data-id="element-54" data-mp="87a0uoqn83bl">
          Una última oportunidad
        </h2>
        <p className="mt-1.5 text-sm leading-snug text-marron/80" data-id="element-55" data-mp="h655vxhyb7db">
          Puedes seguir guardando videos, patrones e ideas y preguntándote qué
          deberías aprender primero. O puedes comenzar hoy a desarrollar esta
          habilidad siguiendo una ruta organizada desde cero.
        </p>
        <p className="mt-1.5 text-sm font-bold text-marron sm:text-base" data-id="element-56" data-mp="14v6kk2hdner1">
          No necesitas saber macramé para empezar.{' '}
          <span className="font-hand text-xl text-olive sm:text-2xl" data-id="element-57" data-mp="zxei4ej3wa8l">Necesitas dar el primer paso.</span>
        </p>

        <div className="mt-3 rounded-2xl border-2 border-terracota bg-crudo p-4" data-id="element-58" data-mp="2c67qql15ve6x">
          <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto block max-w-[14rem] overflow-hidden rounded-xl transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-59" data-mp="2h4spsh4ofrts">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-60" data-mp="2qzks1y97f2uw" />
          </a>
          <p className="mt-2.5 text-sm font-extrabold text-terracota" data-id="element-61" data-mp="2v1od9elodltd">🧶 {PRODUCT_NAME}</p>
          <p className="text-sm font-bold text-marron" data-id="element-62" data-mp="300iuic3zv2bd">6 Tomos + 5 Bonos</p>
          <p className="mt-1 text-sm text-marron/75" data-id="element-63" data-mp="34tu6ernny9a5">
            Valor de los bonos: <span className="line-through" data-id="element-64" data-mp="39sop7tlmrxu9">{BONUS_TOTAL}</span>
          </p>
          <p className="font-serif text-4xl leading-tight text-marron sm:text-5xl" data-id="element-65" data-mp="3errt3apvjy0n">
            Hoy: <span className="text-terracota" data-id="element-66" data-mp="3it3awu2ibeya">{PRICE}</span>
          </p>
          <CtaBlock note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-67" data-mp="3ir0lab59nnu3" />
        </div>
      </div>
    </section>;
}